"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SunburstOptions = /** @class */ (function () {
    function SunburstOptions() {
        this.width = 500;
        this.height = 500;
        this.b = { w: 75, h: 20, s: 3, t: 10, r: 3 };
        this.legend = false;
        this.data = Promise.resolve({});
        this.mapText = function (text) { return text; };
        this.filter = 0.005;
    }
    return SunburstOptions;
}());
exports.default = SunburstOptions;
